import {useStore} from "./useStore";
import {useFetch} from "./useFetch";
import {useTranslation} from "react-i18next";
import {useCallback} from "react";

export const useOptions = ({groupName = ""}) => {
    const stores = useStore();
    const {t} = useTranslation(["options"]);

    const [optionLoading, options] = useFetch({
        fetchFn: stores.optionsStore.getOptionsByGroupName.bind(null, {
            groupName
        }),
        defaultDataValue: {},
        showLoading: false,
        initialCall: true
    });

    const findInOptions = useCallback(
        ({group, value, keyName = "key"}) => {
            if (value === undefined) {
                return "-";
            }

            return keyName === "key"
                ? t(`${group}.${value}`, {ns: "options", defaultValue: value}) || value
                : options?.[group]?.find(item => item?.value === value)?.[keyName] || value;
        },
        [optionLoading, options, t]
    );

    return {options, optionLoading, findInOptions};
};
